import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { AppProviderBlock } from "@components/DataBlocks"
import { BACKEND_APIS } from "@constants"


export default function AppProvidersAutocomplete({ ...props }) {
	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		label="Providers"
		placeholder="All Providers"
		formatOptionLabel={({ label }) => <AppProviderBlock provider={label}/>}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/provider`}
		{...props}
	/>
}